// Axios
import axios from 'axios';

// Endpoints
import { ENDPOINTS_POST, ENDPOINTS_PUT, ENDPOINTS_GET, ENDPOINTS_DELETE } from '@/app/apis/main/_connection/connection-endpoints.js';

// Interceptor
import { apiInterceptor } from '@/app/apis/main/_connection/connection-interceptors.js';

// API Instance
export const instance = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
	headers: {},
	timeout: 30000, // 30 seconds
	validateStatus: status => {
		return status;
	},
});

// API Interceptors
apiInterceptor(instance);

// API Methods
export const API = {
	post(endpoint, formData) {
		return instance.post(endpoint, formData);
	},
	put(endpoint, formData) {
		return instance.put(endpoint, formData);
	},
	get(endpoint, params) {
		return instance.get(endpoint, { params });
	},
	delete(endpoint, formData = null) {
		if(formData){
			return instance.delete(endpoint, formData);
		}
		
		return instance.delete(endpoint);
	},
}

// API Endpoints
export const ENDPOINTS = {
	...ENDPOINTS_POST,
	...ENDPOINTS_PUT,
	...ENDPOINTS_GET,
	...ENDPOINTS_DELETE
}